(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["likha-testimonial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('likha-testimonials')) {
    customElements.define(
      'likha-testimonials',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.likha-testimonials__track');
          if (!this.track) return;
          this.cards = [...this.track.children];
          this.controls = this.querySelector('.likha-testimonials__controls');
          this.motion = matchMedia('(prefers-reduced-motion: reduce)');
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.paused = false;
          this.selected = false;
          this.hovered = false;
          this.index = 0;
          this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1), options);
          this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
          this.querySelector('[data-pause]')?.addEventListener(
            'click',
            (event) => {
              this.paused = !this.paused;
              event.currentTarget.setAttribute('aria-pressed', String(this.paused));
              this.schedule();
            },
            options
          );
          this.addEventListener(
            'mouseenter',
            () => {
              this.hovered = true;
              this.schedule();
            },
            options
          );
          this.addEventListener(
            'mouseleave',
            () => {
              this.hovered = false;
              this.schedule();
            },
            options
          );
          this.addEventListener('focusin', () => this.schedule(), options);
          this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
          this.track.addEventListener(
            'scroll',
            () => {
              this.index = this.nearest();
              this.querySelector('[data-current]').textContent = this.index + 1;
              this.schedule();
            },
            { ...options, passive: true }
          );
          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail.blockId);
              this.selected = true;
              if (index >= 0) this.go(index);
              this.schedule();
            },
            options
          );
          this.addEventListener(
            'shopify:block:deselect',
            () => {
              this.selected = false;
              this.schedule();
            },
            options
          );
          document.addEventListener('visibilitychange', () => this.schedule(), options);
          this.motion.addEventListener('change', () => this.schedule(), options);
          this.resize = new ResizeObserver(() => this.measure());
          this.resize.observe(this.track);
          this.measure();
        }
        nearest() {
          const edge = this.track.getBoundingClientRect();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let nearest = 0;
          let distance = Infinity;
          this.cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect();
            const delta = Math.abs(rtl ? edge.right - rect.right : rect.left - edge.left);
            if (delta < distance) {
              distance = delta;
              nearest = index;
            }
          });
          return Math.min(nearest, this.maxIndex);
        }
        measure() {
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const count = Math.max(
            1,
            Math.round((this.track.clientWidth + gap) / (this.cards[0].getBoundingClientRect().width + gap))
          );
          this.maxIndex = Math.max(0, this.cards.length - count);
          this.controls.hidden = this.maxIndex === 0;
          this.querySelector('[data-total]').textContent = this.maxIndex + 1;
          this.index = this.nearest();
          this.querySelector('[data-current]').textContent = this.index + 1;
          this.schedule();
        }
        go(index) {
          this.index = Math.min(this.maxIndex, Math.max(0, index));
          const edge = this.track.getBoundingClientRect();
          const card = this.cards[this.index].getBoundingClientRect();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.track.scrollBy({
            left: rtl ? card.right - edge.right : card.left - edge.left,
            behavior: this.motion.matches ? 'instant' : 'smooth',
          });
        }
        move(direction) {
          const next = this.index + direction;
          this.go(next > this.maxIndex ? 0 : next < 0 ? this.maxIndex : next);
          this.schedule();
        }
        schedule() {
          clearTimeout(this.timer);
          if (
            this.dataset.autoplay !== 'true' ||
            this.motion.matches ||
            this.paused ||
            this.selected ||
            this.hovered ||
            document.hidden ||
            this.contains(document.activeElement) ||
            !this.maxIndex
          )
            return;
          this.timer = setTimeout(() => this.move(1), Number(this.dataset.interval) || 5000);
        }
        disconnectedCallback() {
          clearTimeout(this.timer);
          this.abort?.abort();
          this.resize?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
